export default __webpack_public_path__ + "static/media/Hamburger_icon.b778cb17.svg";